import { ReactElement, ReactNode } from 'react';
import styles from './feature-icon-with-dot.module.scss';

/**
 * Renders a feature icon with an amber "pending change" dot in its top-right
 * corner. Shared between the devices list Features column and the activation
 * success screen so the indicator looks identical in both places.
 */
export function FeatureIconWithDot(props: {
    pending?: boolean;
    children: ReactNode;
}): ReactElement {
    const { pending = false, children } = props;
    return (
        <span className={styles.wrapper}>
            {children}
            {pending && <span className={styles.pendingDot} />}
        </span>
    );
}
